import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "vab-theme-setting"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vab_icon = _resolveComponent("vab-icon");
  return $setup.theme.showThemeSetting ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [_createElementVNode("li", {
    onClick: $setup.handleOpenTheme
  }, [_createElementVNode("a", null, [_createVNode(_component_vab_icon, {
    icon: "brush-2-line"
  }), _createElementVNode("p", null, _toDisplayString($setup.translate('主题配置')), 1 /* TEXT */)])]), _createElementVNode("li", {
    onClick: $setup.randomTheme
  }, [_createElementVNode("a", null, [_createVNode(_component_vab_icon, {
    icon: "apps-line"
  }), _createElementVNode("p", null, _toDisplayString($setup.translate('随机换肤')), 1 /* TEXT */)])]), _createCommentVNode(" <li @click=\"getCode\">\n            <a>\n                <vab-icon icon=\"file-copy-line\" />\n                <p>{{ translate('拷贝源码') }}</p>\n            </a>\n        </li> "), _createElementVNode("li", {
    onClick: $setup.removeLocalStorage
  }, [_createElementVNode("a", null, [_createVNode(_component_vab_icon, {
    icon: "delete-bin-4-line"
  }), _createElementVNode("p", null, _toDisplayString($setup.translate('清理缓存')), 1 /* TEXT */)])])])) : _createCommentVNode("v-if", true);
}